import { render, staticRenderFns } from "./ParentUpgradeAccount.vue?vue&type=template&id=b953e71c&scoped=true"
import script from "./ParentUpgradeAccount.vue?vue&type=script&lang=js"
export * from "./ParentUpgradeAccount.vue?vue&type=script&lang=js"
import style0 from "./ParentUpgradeAccount.vue?vue&type=style&index=0&id=b953e71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b953e71c",
  null
  
)

export default component.exports